import { FunctionField } from "react-admin";

import { DEFAULT_CURRENCY, getCurrencyByCountry } from "../utils/priceUtils";

export const DiscountedPriceField = ({ country, label }) => (
  <FunctionField
    render={(record) =>
      (
        (record.price - record.price * record.discount) *
        record.quantity
      ).toLocaleString("en-US", {
        style: "currency",
        currency:
          getCurrencyByCountry(country) ||
          getCurrencyByCountry(
            country?.split(".")?.reduce((o, i) => o?.[i], record)
          ) ||
          DEFAULT_CURRENCY,
      })
    }
    label={label}
  />
);
